import { root } from './app/app.module';
import './css/oneui.css';
import './css/maintenance.css';
import './css/style.css';
import './index.scss';
import './app/third/ui-select/dist/select.css';
import * as ng from 'angular';
var app = root;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.ts